/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import React from 'react';
import { checkIsSubMenu } from './checkMenuType.js';
import checkSubMenuChildrenActive from './checkSubMenuChildrenActive.js';
import './type.js';

var checkSubMenuActive = function checkSubMenuActive(children, active) {
  return React.Children.toArray(children).find(function (child) {
    return checkIsSubMenu(child) && (child.props.value === active || checkSubMenuChildrenActive(child.props.children, active));
  });
};

export { checkSubMenuActive as default };
//# sourceMappingURL=checkSubMenuActive.js.map
